import {Footer, Survey} from "../../components";
import React from "react";

export function CreateSurveyPage() {
    return (
        <div>
            <Survey/>
            <Footer/>
        </div>
    )
}
